import type { HelpFile } from '../../types/help'
import { CreateTargetSystemTestIds } from '../../../testids/CreateTargetSystemTestIds'

export const createTargetSystemHelp: HelpFile = {
  docPage: '/docs/systems/overview',
  texts: {
    [CreateTargetSystemTestIds.cardTitleCreateSystem]:
      'Create a new target system of the locked type. Required attributes are derived from the type\u2019s attribute definitions.',
    [CreateTargetSystemTestIds.btnCancelCreateSystem]: null,
    [CreateTargetSystemTestIds.btnSubmitCreateSystem]: null,
    [CreateTargetSystemTestIds.inputSystemName]: null,
    [CreateTargetSystemTestIds.selectEnvironment]: null,
  },
}
